import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import axios from "axios";
import { useAppKitConnection } from '@reown/appkit-adapter-solana/react';
import { modal } from '@reown/appkit/react';
import Loader from "../../components/Loader";
import {
  useDisconnect,
  useAppKit,
  useAppKitNetwork,
  useAppKitAccount,
  useAppKitProvider,
  useAppKitNetworkCore,
} from '@reown/appkit/react';

import {
  BrowserProvider,
  JsonRpcSigner,
} from 'ethers';

import {
  Transaction,
} from '@solana/web3.js';


const API_KEY = '7b31436267f41054790dce44ba7bcf7b8b40433ca53ffb425b2ae813582e8577';
const baseUrl = process.env.REACT_APP_API;


// Crypto logos
const cryptoLogos = {
  USDT: 'https://assets.coingecko.com/coins/images/325/large/Tether.png',
  USDC: 'https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png',
  ETH: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png',
  SOL: 'https://assets.coingecko.com/coins/images/4128/large/solana.png',
  BNB: 'https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png',
  BTC: 'https://assets.coingecko.com/coins/images/1/large/bitcoin.png',
  LTC: 'https://assets.coingecko.com/coins/images/2/large/litecoin.png',
  DOGE: 'https://assets.coingecko.com/coins/images/5/large/dogecoin.png',
  ADA: 'https://assets.coingecko.com/coins/images/975/large/cardano.png',
  TRC20: 'https://assets.coingecko.com/coins/images/325/large/Tether.png',
  RZTO: 'https://via.placeholder.com/40/4e44ce/FFFFFF?text=RZ' // Placeholder for RZTO
};

export default function QuickBuyToken() {
  const navigate = useNavigate();
  // const connection = new Connection('https://api.mainnet-beta.solana.com', 'confirmed');
  
  const [selectedPayment, setSelectedPayment] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [exchangeRates, setExchangeRates] = useState({});
  const [loading, setLoading] = useState(false);
  const [buyTokenLoading, setBuyTokenLoading] = useState(false);
  const [minTransaction, setMinTransaction] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('');
  
  const [qrCode, setQrCode] = useState('');
  const [paymentAddress, setPaymentAddress] = useState('');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState(600);
  const [invoiceId, setInvoiceID] = useState('');
  const [currency, setCurrency] = useState('');
  const [rztoAmount, setRZTOAmount] = useState('');
  const [copied, setCopied] = useState(false);
  const [copiedAddress, setCopiedAddress] = useState(false);
  const [Status, SetStatus] = useState('⏳ Waiting');
  const [status, setStatus] = useState('');
  const [checking, setChecking] = useState(true);

  const [promoCode, setPromoCode] = useState('');
  const [discountAmount, setDiscountAmount] = useState(0);
  const [promoError, setPromoError] = useState('');
  const [promoSuccess, setPromoSuccess] = useState('');
  const [extraToken, setExtraToken] = useState(0);
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [discountedAmount, setDiscountedAmount] = useState(parseFloat(paymentAmount));
  const [ipAddress, setIpAddress] = useState('');
  const [showPostPurchaseNotification, setShowPostPurchaseNotification] = useState(false);
  const [showProcessingPopup, setShowProcessingPopup] = useState(false);


  const handleRegisterClick = () => {
    navigate('/token/signup'); 
    setShowPostPurchaseNotification(false);
  };

  const handleCloseNotification = () => {
    setShowPostPurchaseNotification(false);
  };

  const fetchIpAddress = async () => {
    try {
      const response = await axios.get("https://api64.ipify.org?format=json");
      setIpAddress(response.data.ip);
    } catch (error) {
      console.error("Error fetching IP address:", error);
      setIpAddress('unknown'); 
    }
  };

  useEffect(() => {
    fetchIpAddress();
  }, []);
  

  const { disconnect } = useDisconnect();
  const { chainId } = useAppKitNetworkCore();
  const { isConnected, address } = useAppKitAccount();
  const { walletProvider: ethProvider } = useAppKitProvider('eip155');
  const { walletProvider: solanaProvider } = useAppKitProvider('solana');

  
const { connection } = useAppKitConnection();
 
  const {
    connected,
    disconnect: solDisconnect,
    error: walletError,
  } = useAppKitConnection('solana');
  
  const [walletAddress, setWalletAddress] = useState('');

  useEffect(() => {
    setWalletAddress(address);
  }, [address]);


  const handleConnect = async () => {
    try {
      if (connected) {
        await disconnect();
      } else {
        modal.open('solana');
      }
    } catch (err) {
      console.error('Connection error:', err);
    }
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRemainingTime(prev => {
  //       if (prev <= 1) {
  //         clearInterval(interval);
  //         closeModal();
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);
  
  //   return () => clearInterval(interval); 
  // }, []);

  useEffect(() => {
    if (paymentAmount || selectedPayment) {
      setPromoCode('');
      setPromoError('');
      setPromoSuccess('');
      setDiscountAmount(0);
      setExtraToken(0);
      setAppliedPromo(null);
      setDiscountedAmount(parseFloat(paymentAmount));
    }
  }, [paymentAmount, selectedPayment]);
  
  const applyPromoCode = async () => {
    try {
      setPromoError('');
      setPromoSuccess('');
      setDiscountAmount(0);
      setExtraToken(0);
  
      const usdAmount = selectedPayment === 'USDT' || selectedPayment === 'USDC'
        ? parseFloat(paymentAmount) 
        : calculateUsdtEquivalent();
  
      if (!usdAmount || usdAmount <= 0) {
        const errorMsg = 'Enter a valid amount to apply promo code.';
        setPromoError(errorMsg);
        toast.warning(errorMsg);
        return;
      }
  
      const response = await axios.post(
        `${baseUrl}/api/promo-codes/apply-promo`,
        {
          promoCode: promoCode,
          RizzAmount: calculateReceivedAmount()
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (response.status === 200 && response.data) {
        const { message, discount_type, discount_value, code, extraTokens } = response.data;
        toast.success(message);
  
        setAppliedPromo({
          discount_type,
          discount_value,
          code,
        });
  
        setExtraToken(extraTokens || 0);
  
        let calculatedDiscount = 0;
        let discountedAmount = parseFloat(paymentAmount);
  
        if (discount_type === 'percentage') {
          calculatedDiscount = (discountedAmount * discount_value) / 100;
          discountedAmount -= calculatedDiscount;
        } else if (discount_type === 'flat') {
          calculatedDiscount = discount_value;
          discountedAmount -= calculatedDiscount;
        }
  
        setDiscountAmount(calculatedDiscount);
        setDiscountedAmount(discountedAmount);
        setPromoSuccess(
          `Promo code ${code} applied! You will receive ${extraTokens} bonus tokens.`
        );
      }
    } catch (error) {
      console.error('Promo code error:', error);
      if (error.response?.status === 404) {
        toast.error(error.response.data.error || 'Promo code not found');
      } else {
        toast.error('Invalid promo code');
      }
  
      setPromoError('Invalid or expired promo code');
      setAppliedPromo(null);
      setDiscountAmount(0);
      setDiscountedAmount(0);
      setExtraToken(0);
    }
  };

  // Fetch exchange rates
  useEffect(() => {
    const fetchRates = async () => {
      try {
        setLoading(true);
        const response = await axios.get('https://min-api.cryptocompare.com/data/pricemulti', {
          params: {
            fsyms: 'BTC,ETH,ARB,POL,USDT,USDC,BNB,LTC,DOGE,ADA,SOL,TRX,TRC20',
            tsyms: 'USDT',
          },
          headers: {
            authorization: `Apikey ${API_KEY}`,
          },
        });

        const data = response.data;
        const updatedRates = {
          TRC20: 1,
          USDT: 1,
          USDC: data.USDC?.USDT || 1,
          BTC: data.BTC?.USDT,
          ETH: data.ETH?.USDT,
          ARB: data.ARB?.USDT,
          POL: data.POL?.USDT,
          BNB: data.BNB?.USDT,
          LTC: data.LTC?.USDT,
          DOGE: data.DOGE?.USDT,
          SOL: data.SOL?.USDT,
          RZTO: 0.0040,
        };

        setExchangeRates(updatedRates);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error('Error fetching rates:', err);
      }
    };

    fetchRates();
    const interval = setInterval(fetchRates, 60000);
    return () => clearInterval(interval);
  }, []);

  // Check minimum transaction amount
  useEffect(() => {
    if (!selectedPayment) {
      setMinTransaction(null);
      return;
    }

    const symbolMap = {
      USDT: 'usdt',
      USDC: 'usdc',
      BTC: 'btc',
      ETH: 'eth',
      BNB: 'bnb',
      LTC: 'ltc',
      DOGE: 'doge',
      ADA: 'ada',
      SOL: 'sol',
      RZTO: 'rzto',
    };

    const symbol = symbolMap[selectedPayment] || selectedPayment.toLowerCase();

    fetch(`${baseUrl}/api/payment/min-transaction/${symbol}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.minimum_transaction_coin) {
          setMinTransaction(data.minimum_transaction_coin);
        } else {
          setMinTransaction(null);
        }
      })
      .catch(() => setMinTransaction(null));
  }, [selectedPayment]);

  // Payment status check
  useEffect(() => {
    const checkStatus = async () => {
       if (!invoiceId) return;
      try {
        const response = await axios.get(`${baseUrl}/api/quick-payment/status?invoice_id=${invoiceId}`);
        const data = response.data;

        if (data?.success && data.status === 'completed' && data.transaction?.Status === 'Completed') {
          SetStatus('✅ Completed');
          navigate('/token/quick-buy/payment/success');
          setChecking(false);
          setShowPostPurchaseNotification(true);

          setTimeout(() => {
            navigate('/'); 
          }, 2000);
        }
      } catch (error) {
        console.error('Error checking payment status:', error);
      }
    };

    const interval = setInterval(() => {
      if (checking) {
        checkStatus();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [invoiceId, checking, navigate]);

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentAmount.toString());
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(paymentAddress.toString());
    setCopiedAddress(true);
    setTimeout(() => setCopiedAddress(false), 1500);
  };

  // const closeModal = () => {
  //   setShowProcessingPopup(true);
  //   setShowPaymentModal(false);
    
  //   setTimeout(() => {
  //     setShowProcessingPopup(false);
  //     setShowPostPurchaseNotification(true);
  //     setRemainingTime(600);
  //     setInvoiceID('');
  //   }, 5000);
  // };

    
const closeModal = () => { 
  if (invoiceId) {
    navigate(`/token/quick-buy/payment/status?invoice_id=${invoiceId}`);
  } else {
    // Fallback in case invoiceId is missing (shouldn't happen)
    setTimeout(() => {
      setShowProcessingPopup(false);
      navigate('/token/transactions');
    }, 5000);
  }
};

  const closeCancelModal = () => {
    setShowPaymentModal(false);
    setRemainingTime(600);
    setInvoiceID('');
  }; 

  const calculateUsdtEquivalent = () => {
    if (!paymentAmount || isNaN(parseFloat(paymentAmount))) return 0;
    
    const amount = parseFloat(paymentAmount);
    
    switch(selectedPayment) {
      case 'BTC': return amount * (exchangeRates.BTC || 0);
      case 'ETH': return amount * (exchangeRates.ETH || 0);
      case 'ARB': return amount * (exchangeRates.ARB || 0);
      case 'POL': return amount * (exchangeRates.POL || 0);
      case 'SOL': return amount * (exchangeRates.SOL || 0);
      case 'BNB': return amount * (exchangeRates.BNB || 0);
      case 'LTC': return amount * (exchangeRates.LTC || 0);
      case 'DOGE': return amount * (exchangeRates.DOGE || 0);
      case 'USDC': return amount * (exchangeRates.USDC || 0);
      default: return amount;
    }
  };

  const calculateReceivedAmount = () => {
    if (!paymentAmount || isNaN(paymentAmount)) return '0';
    
    const amount = parseFloat(paymentAmount);
    if (amount <= 0) return '0';
  
    try {
      const paymentRate = exchangeRates[selectedPayment] || 0;
      const usdtValue = amount * paymentRate;
  
      const receiveRate = exchangeRates['RZTO'] || 0;
      const receivedAmount = receiveRate > 0 ? usdtValue / receiveRate : 0;
  
      return receivedAmount.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });
    } catch (err) {
      console.error('Calculation error:', err);
      return '0';
    }
  };

  const handlePaymentAmountChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      setPaymentAmount(value);
    }
  };


//   // ========== Wallet Transaction Functions ==========

const getEthSigner = () => {
  if (!ethProvider || !address) throw new Error("Ethereum wallet not connected.");
  const provider = new BrowserProvider(ethProvider, chainId);
  return new JsonRpcSigner(provider, address);
};

const handleError = (err, context = "Transaction") => {
  console.error(`${context} Error:`, err);

  if (err?.code === 4001 || err?.message?.toLowerCase().includes("user rejected")) {
    toast.error("Transaction rejected by user.");
  } else if (
    err?.message?.toLowerCase().includes("insufficient funds") ||
    err?.message?.toLowerCase().includes("insufficient balance")
  ) {
    toast.error("Insufficient balance to complete the transaction.");
  } else {
    toast.error(`${context} failed. Please try again.`);
  }
};


// const handlePayment = async (e) => {
//   e.preventDefault();

//   if (!paymentMethod) {
//     toast.error("Please slelect payment method.");
//     return;
//   }

//   if (!paymentAmount) {
//     toast.error("Please enter valid amount.");
//     return;
//   }

//   try {
//     setBuyTokenLoading(true);

//     const usdtAmount = selectedPayment === 'USDT'
//       ? parseFloat(paymentAmount)
//       : calculateUsdtEquivalent();

//     const tokenParsed = parseFloat(extraToken);

//     const payload = {
//       walletAddress: address,
//       amount: usdtAmount,
//       promoCode: promoCode || undefined,
//       extraToken: tokenParsed || undefined,
//       currencyAmount: paymentAmount,
//       currency: selectedPayment.toLowerCase(),
//       ipAddress: ipAddress || undefined
//     };

//     const cleanPayload = Object.fromEntries(
//       Object.entries(payload).filter(([_, v]) => v !== undefined)
//     );

//     // SOL PAYMENT
//     if (paymentMethod === 'sol') {
//       if(!solanaProvider){
//         toast.error('Please connect solana wallet');
//         return;
//       }

//       const response = await axios.post(`${baseUrl}/api/quick-payment/process-sol-payment`, cleanPayload);
//       if (!response.data.transaction) throw new Error('Failed to prepare SOL transaction');

//       const transaction = Transaction.from(Buffer.from(response.data.transaction, 'base64'));
//       const signedTx = await solanaProvider.signTransaction(transaction);
//       const signature = await connection.sendRawTransaction(signedTx.serialize());
//       await connection.confirmTransaction(signature, 'confirmed');

//       const confirmResponse = await axios.post(
//         `${baseUrl}/api/quick-payment/confirm-sol-payment`,
//         { ...cleanPayload, txSignature: signature }
//       );

//       if (confirmResponse.data.success) {
//         toast.success("Payment successful! Tokens will be transferred shortly.");
//         setShowPostPurchaseNotification(true);
//       }
//       return;
//     }


//    // ETH / USDT / USDC PAYMENT
// if (['eth', 'usdt', 'usdc'].includes(paymentMethod)) {
//     if(!ethProvider){
//         toast.error('Please connect etherium wallet');
//         return;
//       }
      
//   const { data } = await axios.post(
//     `${baseUrl}/api/quick-payment/process-eth-payment`,
//     cleanPayload
//   );

//   if (paymentMethod === 'eth') {
//     const txParams = {
//       to: data.to,
//       value: data.value || 0,
//       data: data.data || '0x',
//       gasLimit: 21000
//     };

//     const signer = getEthSigner();
//     const tx = await signer.sendTransaction(txParams);
//     const txHash = tx.hash;

//     // Confirm on backend
//     const confirm = await axios.post(
//       `${baseUrl}/api/quick-payment/confirm-eth-payment`,
//       { ...cleanPayload, txHash }
//     );

//     if (confirm.data.success) {
//       toast.success("Payment successful! Tokens will be transferred shortly.");
//       setShowPostPurchaseNotification(true);
//     }

//     return;
//   }

//   // For USDT / USDC
//   const txParams = {
//     from: address,
//     to: data.to,
//     value: data.value,
//     data: data.data
//   };

//   const txHash = await ethProvider.request({
//   method: 'eth_sendTransaction',
//   params: [txParams]
// });

//   const confirm = await axios.post(
//     `${baseUrl}/api/quick-payment/confirm-eth-payment`,
//     { ...cleanPayload, txHash }
//   );

//   if (confirm.data.success) {
//     toast.success("Payment successful!");
//     setShowPostPurchaseNotification(true);
//   }

//   return;
// }

//     // Default / fallback payment method

//     if(!solanaProvider){
//       toast.error('Please connect solana wallet');
//       return;
//     }
//       const amountParsed = parseFloat(paymentAmount);

//       if (minTransaction && amountParsed < parseFloat(minTransaction)) {
//         toast.warning(`Amount must be at least ${minTransaction} ${selectedPayment}`);
//         return;
//       }

//     const response = await axios.post(
//       `${baseUrl}/api/quick-payment/create-payment`,
//       { ...cleanPayload, callback_url: `${baseUrl}/api/quick-payment/callback` }
//     );

//     const { data } = response;
//     if (data?.qr_code_url && data?.payment_address) {
//       setInvoiceID(data.invoiceId);
//       setCurrency(data.currency);
//       setPaymentAmount(data.currencyAmount);
//       setRZTOAmount(data.rztoAmount);
//       setQrCode(data.qr_code_url);
//       setPaymentAddress(data.payment_address);
//       setShowPaymentModal(true);
//     }

//   } catch (error) {
//     console.error("Payment error:", error);
//     let errorMessage = "Payment failed";
//     if (error.message.includes("User rejected")) {
//       errorMessage = "Transaction cancelled by user";
//     } else if (error.response?.data?.error) {
//       errorMessage = error.response.data.error;
//     }
//     toast.error(errorMessage);
//   } finally {
//     setBuyTokenLoading(false);
//   }
// };

// In your QuickBuyToken component

const handlePayment = async (e) => {
  e.preventDefault();

  if (!paymentMethod) {
    toast.error("Please select payment method.");
    return;
  }

  if (!paymentAmount) {
    toast.error("Please enter valid amount.");
    return;
  }

  try {
    setBuyTokenLoading(true);

    const usdtAmount = selectedPayment === 'USDT'
      ? parseFloat(paymentAmount)
      : calculateUsdtEquivalent();

    const tokenParsed = parseFloat(extraToken);

    const payload = {
      walletAddress: address,
      amount: usdtAmount,
      promoCode: promoCode || undefined,
      extraToken: tokenParsed || undefined,
      currencyAmount: paymentAmount,
      currency: selectedPayment.toLowerCase(),
      ipAddress: ipAddress || undefined
    };

    const cleanPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== undefined)
    );

    // SOL PAYMENT
    if (paymentMethod === 'sol') {
      if(!solanaProvider){
        toast.error('Please Solana-compatible wallet');
        return;
      }

      const response = await axios.post(`${baseUrl}/api/quick-payment/process-sol-payment`, cleanPayload);
      if (!response.data.transaction) throw new Error('Failed to prepare SOL transaction');

      const transaction = Transaction.from(Buffer.from(response.data.transaction, 'base64'));
      const signedTx = await solanaProvider.signTransaction(transaction);
      const signature = await connection.sendRawTransaction(signedTx.serialize());
      await connection.confirmTransaction(signature, 'confirmed');

      const confirmResponse = await axios.post(
        `${baseUrl}/api/quick-payment/confirm-sol-payment`,
        { ...cleanPayload, txSignature: signature }
      );

      if (confirmResponse.data.success) {
        // Redirect to success page with query params
        navigate(`/token/quick-buy/payment/success?amount=${paymentAmount}&currency=${selectedPayment}&tx=${signature}`);
        return;
      }
    }

    // ETH/USDT/USDC PAYMENT
    if (['eth', 'usdt', 'usdc'].includes(paymentMethod)) {
      if(!ethProvider){
        toast.error('Please connect Ethereum-compatible wallet');
        return;
      }
      
      const { data } = await axios.post(
        `${baseUrl}/api/quick-payment/process-eth-payment`,
        cleanPayload
      );

      if (paymentMethod === 'eth') {
        const txParams = {
          to: data.to,
          value: data.value || 0,
          data: data.data || '0x',
          gasLimit: 21000
        };

        const signer = getEthSigner();
        const tx = await signer.sendTransaction(txParams);
        const txHash = tx.hash;

        // Confirm on backend
        const confirm = await axios.post(
          `${baseUrl}/api/quick-payment/confirm-eth-payment`,
          { ...cleanPayload, txHash }
        );

        if (confirm.data.success) {
          // Redirect to success page
          navigate(`/token/quick-buy/payment/success?amount=${paymentAmount}&currency=${selectedPayment}&tx=${txHash}`);
          return;
        }
      }

      // For USDT/USDC
      const txParams = {
        from: address,
        to: data.to,
        value: data.value,
        data: data.data
      };

      const txHash = await ethProvider.request({
        method: 'eth_sendTransaction',
        params: [txParams]
      });

      const confirm = await axios.post(
        `${baseUrl}/api/quick-payment/confirm-eth-payment`,
        { ...cleanPayload, txHash }
      );

      if (confirm.data.success) {
        navigate(`/token/quick-buy/payment/success?amount=${paymentAmount}&currency=${selectedPayment}&tx=${txHash}`);
        return;
      }
    }

    // Default payment method
    if(!solanaProvider){
      toast.error('Please connect a Solana-compatible wallet');
      return;
    }
      const amountParsed = parseFloat(paymentAmount);

      if (minTransaction && amountParsed < parseFloat(minTransaction)) {
        toast.warning(`Amount must be at least ${minTransaction} ${selectedPayment}`);
        return;
      }
      const response = await axios.post(
      `${baseUrl}/api/quick-payment/create-payment`,
      { 
        ...cleanPayload, 
        callback_url: `${baseUrl}/api/quick-payment/callback`,
        success_url: `${window.location.origin}/token/quick-buy/payment/success`,
        cancel_url: `${window.location.origin}/token/quick-buy/payment/failed`
      }
    );

    const { data } = response;
    if (data?.qr_code_url && data?.payment_address) {
      setInvoiceID(data.invoiceId);
      setCurrency(data.currency);
      setPaymentAmount(data.currencyAmount);
      setRZTOAmount(data.rztoAmount);
      setQrCode(data.qr_code_url);
      setPaymentAddress(data.payment_address);
      setShowPaymentModal(true);
    }

  } catch (error) {
    console.error("Payment error:", error);
    // Redirect to failure page
    navigate('/token/quick-buy/payment/failed', {
      state: { 
        error: error.message,
        amount: paymentAmount,
        currency: selectedPayment
      }
    });
    disconnect();
  } finally {
    setBuyTokenLoading(false);
  }
};

  const handleCancelTransaction = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/quick-payment/cancel`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          invoice_id: invoiceId,
          status: "Canceled" 
        }),
      });
  
      if (response.ok) {
        closeCancelModal();
        // toast.error('Your transaction is cancelled');
        navigate('/token/quick-buy/payment/failed');
        setInvoiceID('');
        setRemainingTime(600); 
        disconnect();
      } else {
        console.error('Failed to cancel transaction');
      }
    } catch (error) {
      console.error('Error canceling transaction:', error);
    }
  };

  const formatsTime = (seconds) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  if (loading && !Object.values(exchangeRates).some(rate => rate > 0)) {
    return <div><Loader/></div>;
  }

  return (
    <div className="quick-buy-container">
      {showPostPurchaseNotification && (
        <div className="post-purchase-notification-top">
          <div className="notification-content">
            <h3>Unlock Staking Features</h3>
            <p>Create an account to stake your RZTO tokens and earn rewards in your dashboard</p>
            <div className="notification-actions">
              <button 
                className="register-button"
                onClick={handleRegisterClick}
              >
                Register Now
              </button>
              <button 
                className="close-button"
                onClick={handleCloseNotification}
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      )}

      {showProcessingPopup && (
        <div className="processing-notification">
          <div className="processing-content">
            <div className="loader"></div>
            <h3>Transaction Processing</h3>
            <p>On success, RZTO tokens will be credited to your Solana wallet within 5-10 minutes</p>
          </div>
        </div>
      )}

      <div className="quick-buy-card">
        <h1 className="quick-buy-title">Quick Buy RZTO Tokens</h1>
        <div className="price-display">
          <span className="current-price-label">Current price:</span>
          <span className="current-price-value">1 RZTO = ${exchangeRates?.RZTO?.toFixed(4)}</span>
        </div>
       <p className="quick-buy-subtitle">Instant Confirmation Using Your Wallet</p>

        {/* <div
        className="wallet-section"
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '20px',
        }}
      >
        <appkit-button />
      </div> */}
       
       <div className="payment-method-selector">
         <div className="payment-option-container" style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
 
    {/* First row */}
    <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
      <button
        className={`payment-option ${paymentMethod === 'eth' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('eth');
          setSelectedPayment('ETH');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'eth' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.ETH}
            alt="ETH"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            ETH
          </div>
        </div>
      </button>

      {/* SOL */}
      <button
        className={`payment-option ${paymentMethod === 'sol' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('sol');
          setSelectedPayment('SOL');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'sol' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.SOL}
            alt="SOL"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            SOL
          </div>
        </div>
      </button>
    </div>

    {/* Second row */}
    <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
      {/* USDT */}
      <button
        className={`payment-option ${paymentMethod === 'usdt' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('usdt');
          setSelectedPayment('USDT');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'usdt' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.USDT}
            alt="USDT"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            USDT
          </div>
        </div>
      </button>

      {/* USDC */}
      <button
        className={`payment-option ${paymentMethod === 'usdc' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('usdc');
          setSelectedPayment('USDC');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'usdc' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.USDC}
            alt="USDC"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            USDC
          </div>
        </div>
      </button>
    </div>
  </div>

  {/* Other cryptos dropdown */}
  <button
    className={`payment-option ${paymentMethod === 'other' ? 'active' : ''}`}
    onClick={() => {
      setPaymentMethod('other');
      setSelectedPayment('');
    }}
    style={{
      width: '100%',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #444',
      background: paymentMethod === 'other' ? '#4e44ce' : '#333',
      cursor: 'pointer',
      marginTop: '12px',
      marginBottom:'10px'
    }}
  >
    <div
      className="payment-option-content"
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        whiteSpace: 'nowrap',
      }}
    >
       <img
        src={cryptoLogos.BTC}
        alt="BTC"
        style={{ width: '24px', height: '24px', borderRadius: '50%' }}
      />
      <img
        src={cryptoLogos.BNB}
        alt="BNB"
        style={{ width: '24px', height: '24px', borderRadius: '50%' }}
      />
      <div
        className="payment-option-title"
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
        }}
      >
        For Other Crypto Currencies
      </div>
    </div>
  </button>
</div>
      
        <div className="payment-section">
          {paymentMethod === 'other' && (
            <div style={{ marginBottom: '12px' }}>
              <select
                value={selectedPayment}
                onChange={(e) => setSelectedPayment(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '8px',
                  backgroundColor: '#333',
                  color: '#fff',
                  border: '1px solid #555',
                  fontSize: '14px',
                  marginTop:'15px'
                }}
              >
             <option value="">-- Select Currency --</option>
            {Object.keys(exchangeRates)
            .filter((currency) => !['RZTO', 'USDT', 'USDC', 'ETH','SOL'].includes(currency))
            .map((currency) => (
              <option key={currency} value={currency}>
                {currency === 'TRC20' ? 'USDT(TRC20)' : currency}
              </option>
            ))}
              </select>

              {minTransaction && (
                <div style={{ marginTop: '10px', color: 'yellow', fontSize: '14px' }}>
                  Minimum transaction: {minTransaction} {selectedPayment}
                </div>
              )}
            </div>
          )}

          <div className="form-group">
            <label>Amount in {selectedPayment || 'Currency'}</label>
            <input
              type="text"
              value={paymentAmount}
              onChange={handlePaymentAmountChange}
              placeholder="Enter amount"
              disabled={!selectedPayment}
            />
          </div>

          {selectedPayment && !['USDT', 'USDC'].includes(selectedPayment) && paymentAmount && (
            <div className="form-group">
              <label>Amount in USDT</label>
              <div className="usdt-amount">
                {calculateUsdtEquivalent().toFixed(2)} USDT
              </div>
            </div>
          )}

          {/* Promo code section */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap'
            }}>
              <span style={{
                minWidth: '80px',
                color: '#fff',
                fontSize: '14px'
              }}>Promo Code</span>
              <div style={{
                display: 'flex',
                flex: '1',
                minWidth: '200px',
                gap: '8px'
              }}>
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Enter promo code"
                  style={{
                    flex: '1',
                    minWidth: '120px',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid rgb(59, 57, 57)',
                    background: '#333',
                    color: 'white',
                    fontSize: '14px'
                  }}
                />
                <button
                  onClick={applyPromoCode}
                  style={{
                    padding: '10px 16px',
                    whiteSpace: 'nowrap',
                    borderRadius: '8px',
                    border: 'none',
                    background: '#4e44ce',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px'
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          {/* Promo result */}
          {extraToken > 0 && appliedPromo && (
            <div className="bonus-token-info" style={{color:'white', marginTop:'20px'}}>
              🎉 Promo code <strong>{appliedPromo.code}</strong> applied! You will receive <strong>{extraToken}</strong> bonus tokens!
            </div>
          )}

          <div className="form-group" style={{color:'white', marginTop:'20px'}}>
            <label>You will receive</label>
            <div className="receive-amount">
              { (parseFloat(calculateReceivedAmount().toString().replace(/,/g, '')) + extraToken
              ).toLocaleString()} RZTO
            </div>
          </div>

          {status === 'connected' && walletAddress && (
            <p className="wallet-address-container">You will receive RZTO token here: {walletAddress}</p>
          )}

         <div className="wallet-section">
        {isConnected ? (
        <>
        <p className="wallet-address-container">
          Connected Wallet Address : {walletAddress ? `${walletAddress.slice(0, 10)}...${walletAddress.slice(-10)}` : ''}
        </p>
          <button 
            onClick={disconnect}
            className="buy-button"
          >
            Disconnect Wallet
          </button>
          </>
        ) : (
          <div className="wallet-section" style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
          }}>
            {selectedPayment === 'SOL' ? (
              <button 
                onClick={handleConnect}
                    className="buy-button"
              >
                Connect a Solana-compatible wallet
              </button>
            ) : ['ETH', 'USDT', 'USDC'].includes(selectedPayment) ? (
              <button 
                onClick={() => modal.open('eip155')}
                    className="buy-button"
              >
                Connect an Ethereum-compatible wallet
              </button>
            ) : ['BTC','TRC20', 'BNB', 'ARB', 'POL', 'LTC', 'DOGE'].includes(selectedPayment) ? (
              <button 
                onClick={handleConnect}
                    className="buy-button"
              >
                Connect Solana wallet to receive RZTO
              </button>
            ) : (
              ''
            )}
          </div>
        )}
        </div>

          <button
            className="buy-button"
            onClick={handlePayment}
            hidden={!isConnected}
          >
            {buyTokenLoading ? 'Processing...' : 'Buy Tokens'}
          </button>
          {buyTokenLoading && (
        <div className="processing-notification">
          <div className="processing-content">
            <div className="loader"></div>
            <h3>Transaction Processing</h3>
            <p>Please wait, this may take a few moments...</p>
          </div>
        </div>
        )}

        </div>
      </div>

      {showPaymentModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(10px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'Segoe UI, Roboto, sans-serif',
          padding: '1rem',
          zIndex: 9999,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch'
        }}>
          <div style={{
            background: 'rgba(20, 20, 30, 0.95)',
            padding: 'clamp(1rem, 3vw, 1.5rem)',
            borderRadius: 'clamp(0.75rem, 2vw, 1rem)',
            width: '100%',
            maxWidth: 'min(500px, 90vw)',
            boxShadow: '0 0 20px rgba(0, 255, 200, 0.1)',
            color: '#fff',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            maxHeight: '90vh',
            overflowY: 'auto',
            margin: 'auto'
          }}>
            <h1 style={{ 
              fontSize: 'clamp(1.1rem, 4vw, 1.25rem)', 
              fontWeight: 600, 
              marginBottom: 'clamp(0.75rem, 2vw, 1rem)', 
              color: '#0ff' 
            }}>
              Pay with crypto token of your choice
            </h1>

            <p style={{ 
              marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
              fontSize: 'clamp(0.875rem, 3vw, 1rem)'
            }}>
              Send <span style={{ color: '#0ff', fontWeight: 'bold' }}>{paymentAmount} {currency.toUpperCase()}</span> to the address below.
            </p>

            <div style={{ 
              marginBottom: 'clamp(0.75rem, 2vw, 1rem)', 
              fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)'
            }}>
              RZTO WORTH: <strong style={{ color: '#0ff' }}>{rztoAmount}</strong>
            </div>

            <hr style={{ 
              border: 'none', 
              borderTop: '1px solid #333', 
              margin: 'clamp(0.75rem, 2vw, 1rem) 0' 
            }} />

            <div style={{ textAlign: 'center' }}>
              <img 
                src={qrCode} 
                alt="QR Code" 
                style={{
                  width: 'clamp(120px, 50vw, 180px)',
                  height: 'auto',
                  borderRadius: 'clamp(0.25rem, 1vw, 0.5rem)',
                  display: 'inline',
                }} 
              />
              <h2 style={{ 
                fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
                fontWeight: 600, 
                marginTop: 'clamp(0.5rem, 2vw, 0.75rem)'
              }}>
                Scan address from wallet of your choice.  
              </h2>
              <h2 style={{ 
                fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
                fontWeight: 600
              }}>
                OR  
              </h2>
              <h2 style={{ 
                fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
                fontWeight: 600
              }}>
                Use following wallet address to send ( use copy icon to copy address )
              </h2>
              <p style={{ 
                fontSize: 'clamp(0.6875rem, 2.5vw, 0.8125rem)', 
                color: '#bbb', 
                marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
              }}>
                This address is for one-time use only. Your balance will show after network confirmation.
              </p>
            </div>

            <div style={{ marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>
              <h3 style={{ 
                fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', 
                marginBottom: 'clamp(0.25rem, 1vw, 0.375rem)', 
                color: '#0ff' 
              }}>
                Wallet Address
              </h3>
              <div style={{
                backgroundColor: '#111',
                borderRadius: 'clamp(0.25rem, 1vw, 0.375rem)',
                padding: 'clamp(0.5rem, 1.5vw, 0.625rem)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
                <code style={{ 
                  fontFamily: 'monospace', 
                  fontSize: 'clamp(0.6875rem, 2.5vw, 0.8125rem)', 
                  flexGrow: 1 
                }}>
                  {paymentAddress}
                </code>
                <button
                  onClick={handleCopyAddress}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'clamp(0.875rem, 3vw, 1rem)',
                    color: '#0ff',
                    marginLeft: 'clamp(0.25rem, 1vw, 0.5rem)',
                    flexShrink: 0
                  }}
                  title="Copy to clipboard"
                >
                  {copiedAddress ? '✅' : '📋'}
                </button>
              </div>
            </div>

            <div style={{ marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>
              <h3 style={{ 
                fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', 
                marginBottom: 'clamp(0.25rem, 1vw, 0.375rem)', 
                color: '#0ff' 
              }}>
                Payment Amount
              </h3>
              <div style={{
                backgroundColor: '#111',
                borderRadius: 'clamp(0.25rem, 1vw, 0.375rem)',
                padding: 'clamp(0.5rem, 1.5vw, 0.625rem)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap'
              }}>
                <span style={{ fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)' }}>{paymentAmount}</span>
                <button
                  onClick={handleCopy}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#0ff',
                    fontSize: 'clamp(0.875rem, 3vw, 1rem)',
                    marginLeft: 'clamp(0.25rem, 1vw, 0.5rem)',
                    flexShrink: 0
                  }}
                  title="Copy payment amount"
                >
                  {copied ? '✅' : '📋'}
                </button>
              </div>
            </div>

            <hr style={{ 
              border: 'none', 
              borderTop: '1px solid #333', 
              marginBottom: 'clamp(0.75rem, 2vw, 1rem)' 
            }} />

            <table style={{ 
              width: '100%', 
              fontSize: 'clamp(0.6875rem, 2.5vw, 0.8125rem)', 
              color: '#ccc', 
              marginBottom: 'clamp(1rem, 3vw, 1.25rem)' 
            }}>
              <tbody>
                <tr>
                  <td style={{ 
                    padding: 'clamp(0.25rem, 1vw, 0.375rem) 0', 
                    fontWeight: 600 
                  }}>
                    Status
                  </td>
                  <td style={{ 
                    padding: 'clamp(0.25rem, 1vw, 0.375rem) 0' 
                  }}>
                    {Status}
                  </td>
                </tr>
                <tr>
                  <td style={{ 
                    padding: 'clamp(0.25rem, 1vw, 0.375rem) 0', 
                    fontWeight: 600 
                  }}>
                    Expires In
                  </td>
                  <td style={{ 
                    padding: 'clamp(0.25rem, 1vw, 0.375rem) 0' 
                  }}>
                    {formatsTime(remainingTime)}
                  </td>
                </tr>
              </tbody>
            </table>

            <p style={{
              fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)',
              color: '#ccc',
              marginBottom: 'clamp(1rem, 3vw, 1.25rem)',
              lineHeight: '1.5'
            }}>
              After you scan / send payment , you may hit "Payment done" below.<br />
              On successful payment , RZTO Tokens would be sent your wallet. Transfer may get delayed by few minutes due to network congestion.<br />
              For any support please email us at <span style={{ color: '#0ff' }}>info@rzto.io</span>
            </p>

            <button 
              onClick={closeModal} 
              style={{
                width: '100%',
                padding: 'clamp(0.625rem, 2vw, 0.75rem)',
                backgroundColor: '#0ff',
                color: '#000',
                fontWeight: 700,
                border: 'none',
                borderRadius: 'clamp(0.5rem, 1.5vw, 0.625rem)',
                cursor: 'pointer',
                transition: '0.3s ease',
                fontSize: 'clamp(0.875rem, 3vw, 1rem)',
                marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
              }}
            >
              Payment done
            </button>

            <button 
              onClick={handleCancelTransaction} 
              style={{
                width: '100%',
                padding: 'clamp(0.625rem, 2vw, 0.75rem)',
                backgroundColor: 'transparent',
                color: '#ccc',
                fontWeight: 700,
                border: '1px solid #666',
                borderRadius: 'clamp(0.5rem, 1.5vw, 0.625rem)',
                cursor: 'pointer',
                transition: '0.3s ease',
                fontSize: 'clamp(0.875rem, 3vw, 1rem)'
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .quick-buy-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          padding: 20px;
        }
        
        .quick-buy-card {
          background: #1e1e1e;
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 30px;
          width: 100%;
          max-width: 500px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .quick-buy-title {
          color: #fff;
          text-align: center;
          margin-bottom: 10px;
          font-size: 24px;
        }
        
        .quick-buy-subtitle {
          color: rgba(255, 255, 255, 0.7);
          text-align: center;
          font-size: 20px;
          font-weight: bold;
        }
        
        .wallet-section {
          margin-bottom: 25px;
        }
        
        .connect-wallet-button {
          width: 100%;
          padding: 15px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .connect-wallet-button:hover {
          opacity: 0.9;
        }
        
        .connect-wallet-button:disabled {
          background: #666;
          cursor: not-allowed;
        }
        
        .wallet-connected {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(255, 255, 255, 0.1);
          padding: 12px 15px;
          border-radius: 8px;
          color: #fff;
        }
        
        .disconnect-button {
          background: rgba(255, 0, 0, 0.2);
          border: 1px solid rgba(255, 0, 0, 0.3);
          color: #ff6b6b;
          padding: 5px 10px;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .disconnect-button:hover {
          background: rgba(255, 0, 0, 0.3);
        }
        
        .price-display {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-bottom: 20px;
        }
        
        .current-price-label {
          color: rgba(255, 255, 255, 0.8);
        }
        
        .current-price-value {
          color: #fff;
          font-weight: 500;
        }
        
        .wallet-address-container {
          display: flex;
          flex-direction: column;
          color: #fff;
          background: rgba(255, 255, 255, 0.05);
          padding: 12px;
          border-radius: 8px;
        }
        
        .payment-option-container {
          display: flex;
          gap: 12px;
          margin-bottom: 12px;
          flex-wrap: wrap;
        }
        
        .payment-option {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          padding: 10px 15px;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 100px;
          color:white;
        }
        
        .payment-option:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        
        .payment-option.active {
          background: rgba(78, 68, 206, 0.2);
          border-color: #4e44ce;
        }
        
        .payment-option-content {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .payment-option-title {
          font-size: 18px;
          font-weight: bold;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          display: block;
          color: #fff;
          margin-bottom: 8px;
          font-size: 14px;
        }
        
        .form-group select,
        .form-group input {
          width: 100%;
          padding: 12px 15px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
          font-size: 14px;
        }
        
        .form-group select:focus,
        .form-group input:focus {
          outline: none;
          border-color: #4e44ce;
        }
        
        .min-transaction {
          margin-top: 5px;
          color: #f1c40f;
          font-size: 12px;
        }
        
        .usdt-amount,
        .receive-amount {
          padding: 12px 15px;
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
          font-size: 14px;
        }
        
        .buy-button {
          width: 100%;
          padding: 15px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 10px;
        }
        
        .buy-button:hover {
          opacity: 0.9;
        }
        
        .buy-button:disabled {
          background: #666;
          cursor: not-allowed;
        }
        
        .payment-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }
        
        .payment-modal {
          background: #1a1a2e;
          border-radius: 16px;
          padding: 25px;
          width: 90%;
          max-width: 450px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .payment-modal h2 {
          color: #fff;
          text-align: center;
          margin-bottom: 15px;
        }
        
        .payment-modal p {
          color: rgba(255, 255, 255, 0.8);
          text-align: center;
          margin-bottom: 15px;
        }
        
        .qr-code-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;
        }
        
        .qr-code-container img {
          width: 180px;
          height: 180px;
          border-radius: 8px;
        }
        
        .payment-details {
          margin: 20px 0;
        }
        
        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          color: rgba(255, 255, 255, 0.8);
        }
        
        .address-box,
        .amount-box {
          display: flex;
          align-items: center;
          background: rgba(0, 0, 0, 0.3);
          padding: 8px 12px;
          border-radius: 6px;
        }
        
        .address-box code {
          word-break: break-all;
          margin-right: 10px;
        }
        
        .address-box button,
        .amount-box button {
          background: none;
          border: none;
          color: #4e44ce;
          cursor: pointer;
          font-size: 16px;
        }
        
        .modal-actions {
          display: flex;
          gap: 10px;
          margin-top: 20px;
        }
        
        .done-button {
          flex: 1;
          padding: 12px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
        }
        
        .cancel-button {
          flex: 1;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: transparent;
          color: white;
          font-weight: 600;
          cursor: pointer;
        }
        
        .disclaimer {
          margin-top: 20px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          text-align: center;
        }
        
        .post-purchase-notification-top {
          position: fixed;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1000;
          animation: slideDown 0.3s ease-out;
          width: 90%;
          max-width: 500px;
        }
        
        .notification-content {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          border: 1px solid #4e44ce;
          border-radius: 12px;
          padding: 20px;
          width: 100%;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          text-align: center;
          margin-top: 30px;
        }
        
        .notification-content h3 {
          color: #fff;
          margin-bottom: 10px;
          font-size: 18px;
        }
        
        .notification-content p {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 15px;
          font-size: 14px;
        }
        
        .notification-actions {
          display: flex;
          gap: 10px;
          justify-content: center;
        }
        
        .register-button {
          padding: 10px 20px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
        }
        
        .register-button:hover {
          opacity: 0.9;
        }
        
        .close-button {
          padding: 10px 20px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: transparent;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
        }
        
        .close-button:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        
        @keyframes slideDown {
          from {
            transform: translate(-50%, -100px);
            opacity: 0;
          }
          to {
            transform: translate(-50%, 0);
            opacity: 1;
          }
        }

        .processing-notification {
          position: fixed;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1000;
          animation: slideDown 0.3s ease-out;
          width: 90%;
          max-width: 500px;
        }

        .processing-content {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          border: 1px solid #4e44ce;
          border-radius: 12px;
          padding: 20px;
          width: 100%;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 300px;
        }

        .processing-content h3 {
          color: #fff;
          margin: 15px 0 10px;
          font-size: 18px;
        }

        .processing-content p {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 0;
          font-size: 14px;
        }

        .loader {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          border-top-color: #4e44ce;
          margin: 0 auto;
          animation: spin 1s linear infinite;
        }
          .connect-wallet-button {
          padding: 10px 20px;
          background-color: #1e88e5;
          color: white;
          font-weight: bold;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          margin-top:20px;
        }
        .connect-wallet-button:hover {
          background-color: #1565c0;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}